import styled from "styled-components";

export const PageStructure = styled.div`
    display: flex;
`